module.exports = __webpack_public_path__ + "static/media/login_map.48f31de0.png";